export const arTranslations = {
  hello: 'مرحبًا بك!',
  alMuftiGreet: 'مرحبًا بكم في وزارة الأوقاف والشؤون الإسلامية - الكويت. أنا المفتي الذكي AlMufti و انا جزء من فريق كبار العلماء و الأساتذة في مجال الشريعة والإفتاء',
  alMuftiIntro: 'أنا هنا لمساعدتكم في استفساراتكم، وتقديم الفتاوى الدينية الدقيقة والموثوقة، وإرشادكم لاستخدام جميع الخدمات المتاحة على الموقع الرسمي للوزارة.',
  talk: 'ابدأ التحدث',
  startTyping: 'ابدأ الكتابة...',
  en: 'الإنجليزية',
  ar: 'العربية',
  connecting: 'جاري الاتصال',
  tapMic: 'اضغط على الميكروفون للتحدث',
  poweredBy: 'بواسطة',
  alMufti: 'المفتي',
  askByVoice: 'اسأل بالصوت',
  askByText: 'اسأل بالنص',
  backToChat: 'العودة إلى المحادثة',
  backToHome: 'العودة إلى الصفحة الرئيسية',
  talkTo: 'تحدث إلى',
  loading: 'تحميل...',
  back: 'خلف',
  researching: 'جاري البحث',
  alMuftiTalking: 'المفتي  يتحدث',
  alMuftiListening: 'المفتي  يستمع  ',
  tapToTalk: 'اضغط للتحدث',
  tapToPause: 'اضغط للتوقف',
};
